<style scoped>
.replace-label{
	font-weight: bold
}

.order-main .order-info{
	border-top:1px solid #ddd;
  padding: 20px 50px;
	position: relative;
}

.order-main .order-info table{
	border: none;
	display: inline;
  vertical-align: top;
}

.order-main .order-info table>tbody>tr>td{
	padding: 0 5px;
	height: 25px;
	border: none;
}

.order-main .order-info table>thead>tr>td{
	border-bottom: none;
}
.preview-order .info-list>p>.bold{
	font-weight: bold;
}

.order-main .order-info .list-absolute{
	position: absolute;
  left: 60%;
  top: 45px;
}

</style>

<template>
	    <section class="order-main preview-order">
        <div class="content" v-if="hotel.I">
            <div class="hotel-name">
                酒店确认单 <span>CN TRAVEL GROUP</span>
                <div class="logo"><img src="./../../assets/images/logo1.png" alt=""></div>
								<div class="small-title">{{hotel.I.HotelName}}</div>
								
            </div>
            <div class="order-info">
                <div class="info-list">
                    <p ><label class="replace-label">订单号：</label>
                    	<span>
		            				{{hotel.I.PurchaseOrderId}}
		            				<label >({{hotel.I.OrderType}})</label>
			        				</span>
		            		</p>
                    <p><label class="replace-label">住客名称：</label>{{hotel['I'].GuestName}}</p>
										<p><label class="replace-label">入离时间：</label>{{hotel['I'].CheckIn|delUTC|dateToDvd}} - {{hotel['I'].CheckOut|delUTC|dateToDvd}} <span class="bold">	（{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}}晚）</span></p>
										<p><label class="replace-label">总间夜数：</label><span class="bold">{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)*hotel['I'].RoomNum}}</span></p>
										<p><label class="replace-label">房间名称：</label><span class="font-18 color-red">{{hotel['I'].RoomName}} <span class="bold">（{{hotel['I'].RoomNum}}间）</span></span> </p>
										<p><label class="replace-label">特殊要求：</label><span class="color-red">{{hotel['I'].Notes||'无'}}</span></p>
										<p>
											<label class="replace-label">房价信息：</label>
											<table cellspacing="0">
												<tbody>
													<tr v-for="price in hotel.P">
															<td>{{price.CheckIn|delUTC|dateToLineDvd}} ({{price.CheckIn|delUTC|dateWeek}})</td>
															<td>底价 {{price.BaseCurrency}}{{price.BasePrice}}</td>
															<td>{{price.BreakFastName}}</td>
													</tr>
												</tbody>
											</table>
										</p>


										<p>
											<label class="replace-label">附加费用：</label>
											<table cellspacing="0">
												<tbody>
													<tr v-for="overcase in hotel.S" v-if="hotel.S&&hotel.S.length>0">
															<td>{{overcase.SurchargeDate|delUTC|dateToLineDvd}}</td>
															<td>{{overcase.SurchargeTypeName}}（{{overcase.SurchargeName}}）</td>
															<td>{{overcase.BaseCurrency}}{{overcase.BasePrice}}</td>
															<td>{{overcase.SurchargeNum}}份</td>
													</tr>
													<tr v-if="!hotel.S||hotel.S.length<=0">
															<td>暂无</td>
													</tr>
												</tbody>
											</table>
										</p>
										<p><label class="replace-label">共计：</label><span class="font-18 color-red">{{hotel['I'].Currency}} {{hotel['I'].TotalPrice}}</span> （{{hotel['I'].SettlementName}}）</p>
										<p><label class="replace-label">备注：</label>{{hotel['I'].ConfirmRemark||'无'}}</p>
										<p><label class="replace-label">制单人：</label>{{hotel['I'].RealName}}（电话：{{hotel['I'].Phone||'无'}}   传真：{{hotel['I'].Fax||'无'}}）</p>
                </div>
		        			
									<div class="info-list list-absolute">
										<p><label class="replace-label">确认结果：</label>{{hotel['I'].ConfirmResult}}</p>
										<p><label class="replace-label">确认人：</label>{{hotel['I'].Operator }}</p>
                    <p><label class="replace-label">确认号：</label>{{hotel['I'].ConfirmNo||'无'}}</p>
									</div>
                
									<div class="print-comfir-box">
										<div class="print-confirm-btn not-print" @click="PrintOrder">打印预订单</div> 
										<a  class="print-back-btn not-print" onclick="window.history.go(-1)">返回</a>
									</div>
                                     
            </div>
        </div> 
    </section>
		<!-- <section class="order-main preview-order">
        <div class="content">
            <div class="hotel-name">
                酒店确认单 <span>CN TRAVEL GROUP</span>
                <div class="logo"><img src="./../../assets/images/logo1.png" alt=""></div>
            </div>
            <div class="order-info" v-if="hotel.I">
                <div class="info-title not-print">基础信息</div>
                <div class="info-list">
                    <p ><label class="replace-label">订单号：</label>
                    	<span class="font-18 color-red">
		            	{{hotel.I.PurchaseOrderId}}
		            	<label >({{hotel.I.OrderType}})</label>
			        	</span>
		            </p>
                    <p><label class="replace-label">酒店名称：</label>{{hotel.I.HotelName}}</p>
                    <p><label class="replace-label">住客名称：</label>{{hotel['I'].GuestName}}</p>
                    <p><label class="replace-label">特殊要求：</label><span class="color-red">{{hotel['I'].Notes||'无'}}</span></p>
		            <p><label class="replace-label">制单人：</label>{{hotel['I'].RealName}}（电话：{{hotel['I'].Phone||'无'}}   传真：{{hotel['I'].Fax||'无'}}）</p>

                </div>

                <div class="info-title">房价信息</div>
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <td>房型名称</td>
                            <td>入住时间</td>
                             <td>离店时间</td>
                            <td>间数</td>
                            <td>含早情况</td>
                            <td>币种</td>
                            <td>房价</td>
                        </tr>
                    </thead>
                    <tbody>
           		    	<tr v-for="price in hotel.P">
		                    <td>{{price.RoomName}}</td>
		                    <td>{{price.CheckIn|dateToLineDvd}}</td>
		                    <td>{{getNextDay(price.CheckIn)|dateToLineDvd}}</td>
		                    <td>{{price.RoomNum}}</td>
		                    <td>{{price.BreakFastName}}</td>
		                    <td>{{price.BaseCurrency}}</td>
		                    <td>{{price.BasePrice}}</td>
		                </tr>
                    </tbody>
                </table>

                <div class="info-title">附加费用信息</div>
		        <table cellspacing="0">
		            <thead>
		                <tr>
		                    <td>房型名称</td>
		                    <td>附加费用时间</td>
		                    <td>附加费用类型</td>
		                    <td>附加费用名称</td>
		                    <td>币种</td>
		                    <td>单价</td>
		                    <td>数量</td>
		                </tr>
		            </thead>
		            <tbody>
		                <tr v-for="overcase in hotel.S" v-if="hotel.S&&hotel.S.length>0">
		                   
		                    <td>{{overcase.RoomName}}</td>
		                    <td>{{overcase.SurchargeDate|dateToLineDvd}}</td>
		                    <td>{{overcase.SurchargeTypeName}}</td>
		                    <td>{{overcase.SurchargeName}}</td>
		                    <td>{{overcase.BaseCurrency}}</td>
		                    <td>{{overcase.BasePrice}}</td>
		                    <td>{{overcase.SurchargeNum}}</td>
		                </tr>
		                <tr  v-if="!hotel.S||hotel.S.length<=0">
		                    <td colspan="9">暂无数据！</td>
		                </tr>
		            </tbody>
		        </table>

                <div class="info-title">合计</div>
		        <div class="total">
		            <p>共计 <span class="font-18 color-red">{{hotel['I'].Currency}} {{hotel['I'].TotalPrice}}</span>元</p>
	                <p>付款方式：{{hotel['I'].SettlementName}}</p>
                </div>

                <div class="info-list">
                    <p><label>确认结果：</label>{{hotel['I'].ConfirmResult}}
			        	
			        </p>
                    <p><label>确认人：</label>{{hotel['I'].Operator }}</p>
                    <p><label>确认号：</label>{{hotel['I'].ConfirmNo||'无'}}</p>
                    <p><label>备      注：</label>{{hotel['I'].ConfirmRemark||'无'}}</p>
                </div>
				<div class="print-comfir-box">
					 <div class="print-confirm-btn not-print" @click="PrintOrder">打印预订单</div> 
                	<a  class="print-back-btn not-print" onclick="window.history.go(-1)">返回</a>
				</div>
                                     
            </div>
        </div> 
    </section> -->
</template>
<script>
export default {
	name:"orderPrint",
	data(){
		return{
	    	ebID:this.dao.get('ebID'),
	    	VerCol:this.dao.get('VerCol'),
	    	hotel:''
		}
	},
	methods:{
  		initData () {
	        var that=this;
	        var params={
	            ebID: that.ebID,
	            ver: that.VerCol
	        }
	        that.isLoading=true;
	        that.getRequest({
	            url: that.Api.getOrderList,
	            params: params
	        }).then(res => {
	           that.isLoading=false;
	            if (res) {
	                that.hotel=res;
	            } else {
	                that.hotel='';
	                that.error({ title: '提示', content: '没有查询到相关数据' });
	            }
	        });
	    },
  		save (type) {
	        var that=this;
	        var params={
	            EBID: that.ebID,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark,
	            Ver: that.VerCol,
	        }
	       
	        that.isSaving=true;
	        that.patchRequest({
	            url: that.Api.getOrderList+'/'+type,
	            params: params
	        }).then(res => {
	        	
	        	that.isSaving=false;
	            if (res) {
	            	that.error({ title: '提示', content: res.Msg });
					window.history.go(-1);
	            } else {
	                that.error({ title: '提示', content: '没有执行成功，请重试' });
	            }
	        });
	    },
	    PrintOrder() {   
		   // var bdhtml=window.document.body.innerHTML;   
		   // var sprnstr="<!--startprint-->";   
		   // var eprnstr="<!--endprint-->";   
		   // var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);   
		   //  prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr)); 
		   //  console.log(prnhtml);  
		   //  window.document.body.innerHTML=prnhtml;  
		    window.print();   
		},
		confrim () {
	        var that=this;
	        if(!that.hotel['I'].ConfirmNo&&!that.hotel['I'].ConfirmRemark){
	        	that.error({ title: '提示', content: '请输入酒店确认号或备注' });
	        	return;
	        }
	        var params={
	            EBID: that.ebID,
	            Ver:that.VerCol,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark
	        }
	        that.isSaving=true;
	       
	        that.patchRequest({
	            url: that.Api.updateConfrim,
	            params: params
	        }).then(res => {
	        
	        	that.isSaving=false;
	            if (res) {
	            	that.error({ title: '提示', content: res.Msg });
					window.history.go(-1);
	            } else {
	                that.error({ title: '提示', content: '没有执行成功，请重试' });
	            }
	        });
	    }
		
	},
	mounted(){
		this.initData();
	}
}

	
</script>


// WEBPACK FOOTER //
// src/components/order/OrderPrint.vue